<div [class]="tipo" *ngIf="displayModal">
  <h4><i class="icon fa fa-warning"></i>  {{titulo}}</h4>
  {{mensagem}}
</div>
